import { $ } from '@/libs/jquery/index'
import { Messages } from '@/utilities/messages'
import { PopUps } from '@/utilities/popups'

export class SubscribersForm {
  // Footer: subscribers

  private base: JQuery | null = null

  private readonly selectors: ISelectors = {
    base: '[data-selector="footerSubscriber"]',
    form: '[data-selector="footerSubscriberForm"]',
  }

  constructor() {
    this.base = $(this.selectors.base)

    if (this.base.length) {
      this.init()
    }
  }

  public init(): void {
    this.initListeners()
  }

  private initListeners(): void {
    const form: JQuery = this.base.find(this.selectors.form)

    form.validate({
      errorClass: 'error--abs',
      errorElement: 'span',
    })

    form.off('ajax:success').on('ajax:success', () => {
      PopUps.showPopupByContent({
        autoClose: 5000,
        closeCallback: () => window.location.reload(true),
        openCallback: () => form.hide(),
        textContent: Messages.subscriberSuccess(),
      })
    })
  }
}
